import { makeStyles } from '@material-ui/core/styles';

import { RiExternalLinkLine } from '@remixicon/react';

import { Link, Text } from '@backstage/ui';

import { AttachmentFragment } from '@spotify/confidence-graphql';
import { isSafeUrl } from '@spotify/plugin-confidence-artifacts-react';

const useStyles = makeStyles({
  info: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'var(--bui-space-4)',
    padding: 'var(--bui-space-4)',
  },
  link: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 'var(--bui-space-1)',
  },
});

interface ExternalUrlArtifactContentProps {
  artifact: AttachmentFragment;
  fallbackTitle?: (artifact: AttachmentFragment) => string;
}

const defaultFallbackTitle = (artifact: AttachmentFragment) => artifact.uri;

export const ExternalUrlArtifactContent = ({
  artifact,
  fallbackTitle = defaultFallbackTitle,
}: ExternalUrlArtifactContentProps) => {
  const classes = useStyles();
  const label = artifact.displayName || fallbackTitle(artifact);
  const safe = isSafeUrl(artifact.uri);

  return (
    <div className={classes.info}>
      {safe ? (
        <Link
          href={artifact.uri}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.link}
        >
          {label}
          <RiExternalLinkLine size={14} />
        </Link>
      ) : (
        <Text variant="body-medium">{label}</Text>
      )}
    </div>
  );
};
